/*
 * @Author: caizr 13149329917@163.com
 * @Date: 2023-01-03 17:03:58
 * @LastEditors: caizr 13149329917@163.com
 * @LastEditTime: 2023-01-10 16:23:19
 * @FilePath: \cladogram\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App';
import router from './router';

// 引入ElementUI 的样式文件
import Element, { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import './assets/less/common.less';
import 'amfe-flexible/index.js';
import VueSVGIcon from 'vue-svgicon';
import axios from 'axios';
import LazyLoad from './utils/lazyload';
import VueTypedJs from 'vue-typed-js';

const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|webOS|Windows Phone|SymbianOS|IEMobile|Opera Mini/i.test(navigator.userAgent);
sessionStorage.setItem('isMobile', isMobile ? 'isMobile' : ''); // isMobile ? 'isMobile' : ''

Vue.use(Element);
Vue.use(VueSVGIcon);
Vue.use(VueTypedJs);

// Vue.use(LazyLoad);

// 通信公共bus
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js